import { createSlice } from '@reduxjs/toolkit';
import { checkGoldPaymentStatus, getGoldPaymentUrl } from './buyGold.thunk';

interface GoldState {
  paymentUrl: string | null;
  paymentId: string | null;
  loading: boolean;
  error: string | null;
  paymentStatus: {
    amount: number | null;
    isConfirmed: boolean | null;
  };
}

const initialState: GoldState = {
  paymentUrl: null,
  paymentId: null,
  loading: false,
  error: null,
  paymentStatus: {
    amount: null,
    isConfirmed: null,
  },
};

export const buyGoldSlice = createSlice({
  name: 'buyGold',
  initialState,
  reducers: {
    resetGoldState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGoldPaymentUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGoldPaymentUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentUrl = action.payload.url;
        state.paymentId = action.payload.id;
      })
      .addCase(getGoldPaymentUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(checkGoldPaymentStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkGoldPaymentStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentStatus = {
          amount: action.payload.amount,
          isConfirmed: action.payload.isConfirmed,
        };
      })
      .addCase(checkGoldPaymentStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetGoldState } = buyGoldSlice.actions;
export default buyGoldSlice.reducer;
